import { useEffect, useState } from 'react'

import Link from '@atoms/Link'
import ExternalLink from '@icons/ExternalLink'
import CrossMark from '@icons/CrossMark'
import { useTranslation } from '@models/Translation'
import { getLocalData, setLocalData } from '@models/LocalData'

import * as style from './style.module.sass'

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState<boolean>(false)
  const { locale } = useTranslation()

  useEffect(() => {
    setShowConsent(getLocalData('cookie_consent') !== 'remove')
  }, [])

  const removeConsent = () => {
    setShowConsent(false)
    setLocalData('cookie_consent', 'remove')
  }

  return (
    <div className={style.consent} data-show={showConsent}>
      <p className={style.description}>
        {locale === 'en' ? (
          <>
            This website uses cookies to enhance user experience and to analyze
            performance and traffic.
            <br />
            For further information please read our&nbsp;
            <Link to="https://corp.zozo.com/en/cookie/" className={style.link}>
              Cookie Policy
              <ExternalLink />
            </Link>
            .
          </>
        ) : (
          <>
            お客様の利便性向上・閲覧の追跡等のため、クッキーを使用しております。
            詳細は
            <Link to="https://corp.zozo.com/cookie/" className={style.link}>
              クッキーポリシー
              <ExternalLink />
            </Link>
            をご覧ください。
          </>
        )}
      </p>
      <button onClick={removeConsent}>
        <CrossMark />
      </button>
    </div>
  )
}

export default CookieConsent
